<template>
  <p :class="{ 'is-small': isSmall }">
    <slot />
  </p>
</template>

<script lang="ts" setup>
interface TextProps {
  isSmall?: boolean;
}

defineProps<TextProps>();
</script>

<style lang="scss" scoped>
p {
  text-wrap: balance;
  text-align: center;
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.6;
  letter-spacing: 0.033em;
  color: var(--color-white-70);
  max-width: 20rem;
}

p.is-small {
  font-size: 14px;
  font-weight: 300;
  line-height: 1.6;
  letter-spacing: 0.05em;
}
</style>
